<template>
  <div>
    <b-tag :type="type">
      <b-icon  icon="clock" size="is-small"></b-icon>
      <span>{{ label }}</span>
    </b-tag>
  </div>
</template>

<script>
export default {
  name: "ImmediateTravelNote",
  props: {
    severity: String,
  },  
  data() {
    return {

    }
  }, 
  computed: {
    label() {
      let label = ''

      if (this.severity == 'prevent') {
        label = 'Starts in next 4 hours'
      } else if (this.severity == 'warn') {
        label = 'Starts in next 24 hours'
      }

      return label
    },
    type() {
      let type = 'is-info is-light'

      if (this.severity == 'prevent') {
        type = 'is-danger is-light'
      } else if (this.severity == 'warn') {
        type = 'is-warning is-light'
      }

      return type
    },
  }
}

</script>

<style scoped>

</style>
